var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-section uk-section-default",attrs:{"id":"app"}},[_c('h1',{staticClass:"uk-heading-line uk-text-center uk-text-bold"},[_vm._v("N O A H")]),_vm._v(" "),_c('h3',{staticClass:"uk-heading-line uk-text-center"},[_vm._v("Class room Syatem")]),_vm._v(" "),_c('div',{staticClass:"uk-container uk-width-1-2"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b99878a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 